export enum ENTITY_TYPES {
  INVENTORY_ITEM_VENUE = 'inventory-item-venue',
  SITE = 'site',
  TRANSFER = 'transfer',
  RECIPE_VENUE = 'recipe-venue',
  EVENTS = 'events',
  EVENT_TYPE = 'event-type',

  // xea
  POS_COUNT = 'pos-count',

  // boh
  EMPLOYEE = 'employee',
}
